
import React from "react";
import { Route, Routes } from "react-router-dom";
import { RequirePermission } from "@comps/components";
import Dashboard from "./dashboard/IndexDashboard";
import UserManagementRoutes from "./userManagement/routes";
import Setting from "./settings/IndexSetting";
import Profile from "./userManagement/profile/IndexProfile";
import ChangePassword from "./userManagement/profile/IndexChangePassword";
import CaseManagementRoutes from "./caseManagement/routes";
import UserCaseManagementRoutes from "./userCase/routes";
import IndexClinics from "./clinics/IndexClinics";


const ModuleRoutes = () => {
  return (
    <Routes>
      <Route index path="/" element={ <Dashboard /> } />
      <Route path="/user-management/*" element={ <UserManagementRoutes /> } />
      <Route path="/case-management/*" element={ <CaseManagementRoutes /> } />
      <Route path="/cases/*" element={ <UserCaseManagementRoutes /> } />
      <Route index path="/settings" element={ <RequirePermission permission="settings_index"><Setting /></RequirePermission> } />
      <Route index path="/profile" element={ <Profile /> } />
      <Route index path="/change-password" element={ <ChangePassword /> } />
      <Route index path="/clinics" element={ <RequirePermission permission="clinics_index"><IndexClinics /></RequirePermission> } />
    </Routes>
  )

}

export default ModuleRoutes;
